import React from 'react';
import '../styles/Skeleton.scss'; 

const Skeleton = () => {
  return <div className="skeleton"></div>;
};

export default Skeleton;